// src/firebase/index.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, logEvent } from "firebase/analytics";
const isMobile = (): boolean => {
  // 方法1: 检查屏幕宽度
  const byScreenWidth = window.innerWidth <= 700;

  // 方法2: 检查用户代理
  const byUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  // 方法3: 检查触摸点数量 (触摸设备通常有这个属性)
  const byTouchPoints = navigator.maxTouchPoints > 0;

  // 综合判断: 任一条件满足即认为是移动设备
  return byScreenWidth || byUserAgent || byTouchPoints;
};
/**
 * 从本地存储获取用户ID
 * @returns {string} 用户ID，如果未登录则返回空字符串
 */
const getUserId = (): string => {
  try {
    // 尝试从localStorage获取用户数据
    const userDataStr = localStorage.getItem('userdata');
    if (userDataStr) {
      const userData = JSON.parse(userDataStr);
      return userData.id || '';
    }
    return '';
  } catch (error) {
    console.error('获取用户ID时出错:', error);
    return '';
  }
};

// const firebaseConfig = {
//     apiKey: "您的API密钥",
//     authDomain: "您的项目域名.firebaseapp.com",
//     projectId: "您的项目ID",
//     storageBucket: "您的项目ID.appspot.com",
//     messagingSenderId: "您的消息发送者ID",
//     appId: "您的应用ID",
//     measurementId: "您的测量ID"
// };
const firebaseConfig = {
  apiKey: "AIzaSyA0gh7Egw9ZdRYgudJZBxHdI3QfhgouFzU",
  authDomain: "iglees.firebaseapp.com",
  projectId: "iglees",
  storageBucket: "iglees.firebasestorage.app",
  messagingSenderId: "732884545653",
  appId: "1:732884545653:web:b92ccc473979b53e84483c",
  measurementId: "G-84L2HDLNBB"
};

const app = initializeApp(firebaseConfig);

// 根据需要导出服务
/**
 * Authentication（身份验证）：用于用户登录、注册等
 */
export const auth = getAuth(app);
/**
 * Firestore Database（云数据库）：用于存储和同步数据
 */
export const db = getFirestore(app);
/**
 * Storage（存储）：用于文件存储（如图片、视频等）
 */
export const storage = getStorage(app);
/**
 * Analytics（分析）：用于分析用户行为
 */
export const analytics = getAnalytics(app);

/**
 * 封装的事件记录函数
 * @param eventName 事件名称
 * @param eventParams 事件参数
 */
export const logEventAnalytics = (eventName: string, eventParams: any = {}) => {
  // 获取最新的用户ID
  const uid = getUserId();

  // 获取平台信息
  const platform = isMobile() ? "mobile" : "pc";

  // 合并参数，确保uid和platform总是存在
  const mergedParams = {
    ...eventParams,
    uid: eventParams['uid'] || uid, // 如果调用时提供了uid，则使用提供的值
    platform: eventParams['platform'] || platform // 如果调用时提供了platform，则使用提供的值
  };

  // 记录事件
  logEvent(analytics, eventName, mergedParams);
};

export default app;